export default function ProductsSection() {
  return (
    <section id="products" className="py-32 px-20 max-w-[1440px] mx-auto">
      <div className="flex items-start justify-between mb-20">
        <div>
          <div className="text-base uppercase tracking-[2px] text-[#A8A8A8] mb-3">
            OUR PRODUCTS
          </div>
          <h3 className="text-[56px] font-bold text-[#1A1A1A] leading-tight">
            Innovative Solutions
          </h3>
        </div>
        
        <p className="text-[17px] text-[#707070] leading-relaxed max-w-[320px]">
          Discover our suite of iOS applications designed to enhance security, optimize performance, and deliver exceptional user experiences.
        </p>
      </div>

      <div className="grid grid-cols-3 gap-8" data-product-shop>
        <div className="bg-[#FDFAF6] border-2 border-[#E8E3DB] rounded-3xl p-10 hover:shadow-[0_12px_48px_rgba(0,0,0,0.08)] transition-all duration-300 hover:-translate-y-1 cursor-pointer">
          <div className="mb-6 rounded-2xl overflow-hidden bg-gradient-to-br from-[#1E2A3A] to-[#2B3F52] aspect-[9/16] relative">
            <img
              src="https://public.readdy.ai/ai/img_res/41286e5b10e7a44e43deaa097762ed5f.jpg"
              alt="VPN Application Interface"
              className="w-full h-full object-cover"
            />
          </div>
          
          <div className="inline-block px-4 py-2 bg-[#E8F5A8] rounded-full mb-4">
            <span className="text-xs font-medium text-[#2B2B2B]">Security &amp; Privacy</span>
          </div>
          
          <h4 className="text-[28px] font-bold text-[#2D2D2D] mb-3">
            VPN Protection
          </h4>
          
          <p className="text-[15px] text-[#6A6A6A] leading-relaxed">
            Secure your online presence with our advanced VPN solution. Enjoy encrypted connections, anonymous browsing, and protection across all your iOS devices.
          </p>
        </div>

        <div className="bg-[#FDFAF6] border-2 border-[#E8E3DB] rounded-3xl p-10 hover:shadow-[0_12px_48px_rgba(0,0,0,0.08)] transition-all duration-300 hover:-translate-y-1 cursor-pointer">
          <div className="text-center mb-6">
            <h4 className="text-[28px] font-bold text-[#2D2D2D] mb-8">
              Device Cleaner
            </h4>
            
            <div className="h-[200px] flex items-center justify-center mb-6">
              <img
                src="https://readdy.ai/api/search-image?query=minimalist%20icon%20illustration%20representing%20device%20cleaning%20and%20optimization%20concept%2C%20abstract%20geometric%20shapes%20showing%20storage%20cleanup%20and%20performance%20boost%2C%20dark%20navy%20blue%20background%20with%20bright%20neon%20lime%20yellow%20accent%20elements%2C%20modern%20tech%20iconography%20with%20circular%20progress%20indicators%20and%20sparkle%20effects%2C%20clean%20professional%20style&width=400&height=400&seq=cleaner-icon&orientation=squarish"
                alt="Device Cleaner Icon"
                className="w-full h-full object-contain"
              />
            </div>
            
            <div className="inline-block px-4 py-2 bg-[#E8F5A8] rounded-full mb-4">
              <span className="text-xs font-medium text-[#2B2B2B]">Performance</span>
            </div>
          </div>
          
          <p className="text-[15px] text-[#6A6A6A] leading-relaxed">
            Optimize your device performance with intelligent cleaning algorithms. Remove junk files, manage storage, and keep your iOS device running smoothly.
          </p>
        </div>

        <div className="bg-[#FDFAF6] border-2 border-[#E8E3DB] rounded-3xl p-10 hover:shadow-[0_12px_48px_rgba(0,0,0,0.08)] transition-all duration-300 hover:-translate-y-1 cursor-pointer opacity-75">
          <div className="mb-6 rounded-2xl overflow-hidden bg-gradient-to-br from-[#3A2E2E] to-[#5A4E4E] aspect-[9/16] relative flex items-center justify-center">
            <img
              src="https://readdy.ai/api/search-image?query=abstract%20futuristic%20iOS%20app%20preview%20with%20blurred%20interface%20elements%20suggesting%20upcoming%20features%2C%20soft%20focus%20mobile%20application%20mockup%20with%20mysterious%20gradient%20overlay%2C%20modern%20tech%20aesthetic%20with%20purple%20and%20teal%20color%20scheme%2C%20coming%20soon%20teaser%20design%20with%20elegant%20composition%20and%20professional%20polish&width=400&height=711&seq=future-app-preview&orientation=portrait"
              alt="Coming Soon Preview"
              className="w-full h-full object-cover opacity-60"
            />
            <div className="absolute inset-0 flex items-center justify-center">
              <span className="text-white text-2xl font-semibold">More Coming</span>
            </div>
          </div>
          
          <div className="inline-block px-4 py-2 bg-[#E8F5A8] rounded-full mb-4">
            <span className="text-xs font-medium text-[#2B2B2B]">Coming Soon</span>
          </div>
          
          <h4 className="text-[28px] font-bold text-[#2D2D2D] mb-3">
            Future Innovation
          </h4>
          
          <p className="text-[15px] text-[#6A6A6A] leading-relaxed">
            We're constantly innovating and developing new solutions to meet the evolving needs of iOS users. Stay tuned for exciting announcements.
          </p>
        </div>
      </div>
    </section>
  );
}
